"use client";

import { Box } from "@cloudspire/shared/components/ui/box";
import { memo, useCallback, useEffect, useRef, useState } from "react";

export const AutoHeight = memo(
  /**
   * @typedef {object} Props
   * @prop {React.ReactNode} children
   */
  /**
   * @param {Props} props
   */
  function AutoHeight({ children }) {
    const contentRef = useRef(/** @type {HTMLDivElement | null} */ (null));
    const containerRef = useRef(/** @type {HTMLDivElement | null} */ (null));

    const [isResizing, setIsResizing] = useState(false);

    useEffect(() => {
      const contentEl = contentRef.current;
      const containerEl = containerRef.current;

      if (contentEl && containerEl) {
        const resizeObserver = new ResizeObserver(() => {
          containerEl.style.setProperty(
            "--content-height",
            `${contentEl.scrollHeight}px`,
          );
          setIsResizing(true);
        });
        resizeObserver.observe(contentEl);
        return () => resizeObserver.disconnect();
      }
    }, []);

    const handleTransitionEnd = useCallback(() => {
      setIsResizing(false);
    }, []);

    return (
      <Box
        ref={containerRef}
        overflow={isResizing ? "hidden" : "visible"}
        height="var(--content-height, auto)"
        transition="height .2s ease"
        onTransitionEnd={handleTransitionEnd}
        data-component="AutoHeight"
      >
        <Box ref={contentRef}>{children}</Box>
      </Box>
    );
  },
);
